import * as React from 'react';

import { Props } from './types';

const TrophyIcon = ({ className }: Props) => (
  <svg
    data-testid="trophy-icon"
    className={className}
    width="8"
    height="8"
    viewBox="0 0 8 8"
    fill="none"
  >
    <path
      d="M7.818 0.6812H6.5384C6.5528 0.4576 6.5628 0.2316 6.5628 0H1.2888C1.2888 0.2316 1.2984 0.4576 1.3128 0.6812H0C0 2.7536 1.1552 4.45 2.6232 4.6132C2.7208 4.7248 2.8212 4.8256 2.9256 4.9116H2.8712V5.4424H3.3988V6.4064H2.8712V6.9372H2.3436V7.9996H5.5076V6.9376H4.9804V6.4064H4.4528V5.4424H4.9804V4.9116H4.926C5.0316 4.8248 5.1324 4.7224 5.2304 4.6108C6.6812 4.4244 7.818 2.7368 7.818 0.6808V0.6812ZM6.4908 1.212H7.2624C7.1268 2.4824 6.5124 3.52 5.7004 3.9196C6.062 3.1968 6.3676 2.2732 6.4908 1.212ZM0.5556 1.212H1.3608C1.4852 2.284 1.7708 3.2284 2.1632 3.9408C1.3292 3.5584 0.6936 2.5052 0.5556 1.212Z"
      fill="#546D91"
    />
  </svg>
);

export default TrophyIcon;
